import styled from 'styled-components'

export const QuestionsList = styled.div<{ $expanded: boolean }>`
	display: flex;
	flex-wrap: wrap;
	gap: 30px 25px;
	margin: 30px 0;

	@media (max-width: 1024px) {
		gap: 20px 10px;
	}

	@media (max-width: 425px) {
		gap: 10px;
		max-height: ${({ $expanded }) => ($expanded ? 'none' : '60px')};
		overflow: hidden;
	}
`
export const QuestionItem = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #555;

	white-space: nowrap;

	&::before {
		content: '/';
		margin-right: 4px;
		color: #888;
	}

	@media (max-width: 768px) {
		font-size: 11px;
		white-space: wrap;
	}
`

export const ShowMoreButton = styled.button`
	display: none;
	background: none;
	border: none;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 13px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #01924f;
	margin-top: -20px;

	cursor: pointer;
	padding: 0;
	margin-left: auto;

	@media (max-width: 425px) {
		display: block;
	}
`
